<template>
    <div>
        <v-layout row wrap>
            <v-flex sm12 md3 style="padding: 0 5px 0 5px">
                <v-card>
                    <v-toolbar class="primary-color" dense flat dark>
                        Search &amp; Filtering
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field 
                            v-model="searchText" 
                            append-icon="search" 
                            label="Search Phone Number" 
                            single-line 
                            hide-details
                            @keyup.enter="search" 
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn @click="searchText='';search()">
                            Clear
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="search()"
                        >
                            Search
                        </v-btn>
                        <v-spacer/>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex sm12 md9 style="padding: 0 5px 0 5px">
                <v-card>
                    <v-toolbar flat color="primary" dark dense>
                        Unknown SMS
                    </v-toolbar>
                    <v-card-text style="padding: 0;">
                        <v-alert
                            :value="true"
                            type="info"
                        >
                            This pool represents SMS messages received from phone numbers not associated with any Contacts in the organization. These messages are stored here for review.
                        </v-alert>
                        <v-data-table
                            :items="unknownSMS"
                            :headers="headers"
                            :pagination.sync="pagination"
                            :total-items="totalUnknownSMS"
                            :rows-per-page-items="paginationStrings"
                            :loading="loading"
                        >
                            <template v-slot:no-data>
                                <tr>
                                    <td :colspan="headers.length">
                                        <div style="text-align: center; padding:25px;">
                                            <v-icon size="125px">find_in_page</v-icon>
                                            <h3>No Results</h3>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template slot="items" slot-scope="item">
                                <tr>
                                    <td>
                                        {{ item.item.phone_number }}
                                    </td>
                                    <td>
                                        {{ convertToLocal(item.item.received_at) }}
                                    </td>
                                    <td>
                                        {{ item.item.message }}
                                    </td>
                                </tr>
                            </template>
                            <template slot="actions-append">
                                <v-tooltip left>
                                    <v-btn
                                        round
                                        flat
                                        fab
                                        small
                                        @click="downloadCsv()"
                                        slot="activator"
                                    >
                                        <v-icon
                                            color="green"
                                        >   
                                            table_chart
                                        </v-icon>
                                    </v-btn>
                                    <span>Download CSV<br /><small>Of Current Search Terms</small></span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import api from '@/api'
import pagination from '@/components/global/pagination'

export default {
    name: 'OrgUnknownSMS',
    mixins: [
        pagination
    ],
    data() {
        return {
            unknownSMS: [],
            headers: [
                { text: 'Phone Number', value: 'phone_number', sortable: false },
                { text: 'Received At', value: 'received_at' },
                { text: 'Message', value: 'message'}
            ],
            loading: false,
            pagination: {},
            paginationStrings: [
                10, 25, 50
            ],
            searchText: ''
        }
    },
    computed: {
        totalUnknownSMS() {
            return this.pagination.totalItems
        }
    },
    methods: {
        fetch () {
            this.loading = true
            api.sms.unknownSMS.list({
                search: this.searchText,
                ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy,
                pageNum: this.pagination.page,
            }).then(data =>{
                this.unknownSMS = data.results
                this.loading = false
            })
        },
        downloadCsv(){
            api.sms.unknownSMS.downloadCsv({
                search: this.searchText
            }).then(response => {
                let blob = new Blob([response.data])
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Export_UnknownSMS.csv'
                link.click()
            })
        },
        search () {
            this.pagination.page = 1
            var queryParam = {}, filterQueryParam = {}
            if (this.searchText) {queryParam['search'] = this.searchText}
            if (Object.keys(filterQueryParam).length !== 0) {queryParam['filter'] = JSON.stringify(filterQueryParam)}
            this.$router.push({ query: queryParam })
        }
    }
}
</script>

<style scoped>
</style>